import { create } from 'zustand';

// 페이지 내 html 요소의 id를 이용해 해당 요소를 찾아 스크롤 위치를 변경하는 기능을 제공하는 스토어

interface ScrollTarget {
    type: 'feedback' | 'feedback_request' | 'dailyscrum'; // 여기에 타입을 추가
    id: string; // html(jsx) 요소의 id - 이 요소를 찾아 스크롤할 것임
}

interface PendingScrollState {
    target: ScrollTarget | null;
    setScrollTarget: (target: ScrollTarget | null) => void;
}

export const usePendingScrollStore = create<PendingScrollState>(set => ({
    target: null,
    setScrollTarget: target => set({ target }),
}));
